import { FilterInput } from '../Interfaces/Responses/Dashboard/FilterInput';

export const filterInputArrayToIdArray = (
    filterInputs: FilterInput[]
): string[] => {
    return filterInputs
        .filter((input) => input.hasValue)
        .map((input) => {
            return input.input.id.toString();
        });
};

export const filterInputArrayToValueArray = (
    filterInputs: FilterInput[]
): string[] => {
    return filterInputs
        .filter((input) => input.hasValue)
        .map((input) => {
            if (input.input.dataFormat === 'DateTime') {
                const options: Intl.DateTimeFormatOptions = {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                };
                if (input.input.selector === 'between') {
                    var ldate = new Date(
                        input.value.split('|')[0]
                    ).toLocaleDateString('en-US', options);
                    var rdate = new Date(
                        input.value.split('|')[1]
                    ).toLocaleDateString('en-US', options);
                    return `${ldate}|${rdate}`;
                }
                const date = new Date(input.value);
                return date.toLocaleDateString('en-US', options);
            }
            return input.value;
        });
};
